import { SettingsPage } from 'Features/Projects/Scenarios/EditSettings/SettingsPage'

export const LocationGroupingView = () => {
  return <SettingsPage title="Location grouping" />
}
